import {CompetitionSeason} from '../resources/CompetitionSeason';
import {EntityExportAvailableEvent} from './EntityExportAvailableEvent';

/**
 * This event can be fired to indicate that some data as requested via the
 * {@see CompetitionSeasonsExportRequested} event is available and can be processed.
 */
export class CompetitionSeasonsExportAvailable extends EntityExportAvailableEvent<CompetitionSeason> {
}
